import http from "../../services/http";

const getTiposVinculos = async () => {
  return await http("get", `v1/tipos_vinculos/listar`, []);
};

export { getTiposVinculos };
